import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import logo from '../../assets/img/logo-green.svg';

class EndProject extends React.Component {
  render() {
    const {
      closedAt,
      eligibleForSubscription,
      beginDate,
      endDate
    } = this.props;

    return (
      <Fragment>
        <div className="login-background">
          <div className="manutencao-card shadow p-5 text-center">
            <div className="text-center mb-5">
              <img
                src={logo}
                alt="notification"
                style={{ maxWidth: '18rem' }}
              />
            </div>
            <div className="text-center  mb-3 ">
              <h3
                className="mb-3"
                style={{ fontWeight: 100, color: '#777777' }}
              >
                Prezado(a) Candidato(a)
              </h3>
              {eligibleForSubscription ? (
                <>
                  <h3
                    className="mb-3"
                    style={{ fontWeight: 100, color: '#777777' }}
                  >
                    O processo de inscrição inicia em <b>{beginDate}</b> e
                    encerra em <b>{endDate}</b>
                  </h3>
                </>
              ) : (
                <>
                  <h3
                    className="mb-3"
                    style={{ fontWeight: 100, color: '#777777' }}
                  >
                    O processo de Matrícula encerrou em:
                  </h3>
                  <h3 style={{ fontWeight: 700, color: '#777777' }}>
                    {endDate}
                  </h3>
                </>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

EndProject.propTypes = {
  closedAt: PropTypes.string.isRequired
};

export default EndProject;
